module.exports = __webpack_public_path__ + "static/img/11areaA_09.c5b4c52.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/11areaA_09.png
// module id = 1002
// module chunks = 1